require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./absolute-and-marvelous.json") })
        }
      }, "path---absolute-and-marvelous");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---absolute-and-marvelous!./.cache/json/absolute-and-marvelous.json
// module id = 831
// module chunks = 231608221292675